import React, { Component } from "react";

export default class TeamLeadImg extends Component {
  render() {
    const theme = this.props.theme;
    const primary = theme.imageHighlight || "#0E6BA8";
    const accent = theme.headerColor || "#0E6BA877";
    const surface = theme.body || "#ffffff";
    const ink = theme.text || "#001C55";

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80%"
        height="auto"
        viewBox="0 0 500 400"
        fill="none"
        aria-label="Leadership and AI workflow"
      >
        <ellipse cx="250" cy="370" rx="180" ry="14" fill={accent} opacity="0.4" />

        {/* AI sparkle hub */}
        <g transform="translate(250,140)">
          <circle r="68" fill={primary} opacity="0.12" />
          <circle r="48" fill={primary} opacity="0.22" />
          <circle r="32" fill={primary} />
          <path
            d="M0,-18 L4,-4 L18,0 L4,4 L0,18 L-4,4 L-18,0 L-4,-4 Z"
            fill={surface}
          />
          <circle cx="14" cy="-14" r="3" fill={surface} opacity="0.9" />
          <circle cx="-14" cy="14" r="2.5" fill={surface} opacity="0.7" />
        </g>

        {/* connection lines from AI to team */}
        <line x1="200" y1="170" x2="120" y2="240" stroke={primary} strokeWidth="2" strokeDasharray="4 4" opacity="0.55" />
        <line x1="250" y1="190" x2="250" y2="240" stroke={primary} strokeWidth="2" strokeDasharray="4 4" opacity="0.55" />
        <line x1="300" y1="170" x2="380" y2="240" stroke={primary} strokeWidth="2" strokeDasharray="4 4" opacity="0.55" />

        {/* team members */}
        {[
          { x: 120, scale: 1, role: "engineer" },
          { x: 250, scale: 1.1, role: "lead" },
          { x: 380, scale: 1, role: "engineer" },
        ].map((p) => (
          <g key={p.x} transform={`translate(${p.x},280) scale(${p.scale})`}>
            <circle cx="0" cy="-30" r="18" fill={primary} />
            <path
              d="M-30,30 C-30,5 -18,-8 0,-8 C18,-8 30,5 30,30 L30,42 L-30,42 Z"
              fill={primary}
              opacity="0.85"
            />
            {p.role === "lead" ? (
              <path
                d="M0,12 L3,20 L11,20 L5,25 L8,33 L0,28 L-8,33 L-5,25 L-11,20 L-3,20 Z"
                fill={surface}
              />
            ) : (
              <circle cx="0" cy="20" r="4" fill={surface} opacity="0.85" />
            )}
          </g>
        ))}

        {/* code review chat bubbles */}
        <g transform="translate(60,80)">
          <rect width="80" height="46" rx="10" fill={primary} opacity="0.9" />
          <rect x="10" y="14" width="48" height="5" rx="2" fill={surface} />
          <rect x="10" y="26" width="36" height="5" rx="2" fill={surface} opacity="0.8" />
          <path d="M14,46 L20,58 L26,46 Z" fill={primary} opacity="0.9" />
        </g>

        <g transform="translate(360,80)">
          <rect width="80" height="46" rx="10" fill={ink} opacity="0.85" />
          <rect x="10" y="14" width="60" height="5" rx="2" fill={surface} />
          <rect x="10" y="26" width="40" height="5" rx="2" fill={surface} opacity="0.8" />
          <path d="M54,46 L60,58 L66,46 Z" fill={ink} opacity="0.85" />
        </g>

        <path d="M70,200 l3,-8 l3,8 l8,3 l-8,3 l-3,8 l-3,-8 l-8,-3 z" fill={primary} opacity="0.5" />
        <path d="M430,180 l2,-6 l2,6 l6,2 l-6,2 l-2,6 l-2,-6 l-6,-2 z" fill={primary} opacity="0.5" />
      </svg>
    );
  }
}
